import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductAttribute,
  updateProductAttribute,
  fetchProductAttributes,
  selectCreateLoading,
  selectUpdateLoading,
  selectProductAttributeError,
} from "../../../slices/company/productAttributeSlice";
import { Delete } from "lucide-react";

const ProductAttributeForm = ({ show, onClose, heading, initialData }) => {
  const dispatch = useDispatch();
  const createLoading = useSelector(selectCreateLoading);
  const updateLoading = useSelector(selectUpdateLoading);
  const error = useSelector(selectProductAttributeError);
  const [tagInput, setTagInput] = useState('');

  const [formData, setFormData] = useState({
    name: "",
    tags: [],
  });
  
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        tags: Array.isArray(initialData.tags) ? initialData.tags : [],
      });
    } else {
      setFormData({ name: "", tags: [] });
    }
  }, [initialData, show]);

  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const company = JSON.parse(localStorage.getItem("company"));
    const companyId = company?.company?.id;
    // const tagsArray = formData.tags
    //   .split(",")
    //   .map((tag) => tag.trim())
    //   .filter((tag) => tag.length > 0);
    if (initialData && initialData.id) {
      await dispatch(
        updateProductAttribute({
          id: initialData.id,
          updateData: { name: formData.name, tags: formData.tags },
        })
      );
    } else {
      await dispatch(
        createProductAttribute({
          name: formData.name,
          tags: formData.tags,
          company_id: companyId,
        })
      );
    }
    // Refresh list after submit
    if (companyId) dispatch(fetchProductAttributes(companyId));
    onClose();
  };

  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const trimmed = tagInput.trim().replace(/,$/, '');
      if (trimmed && !formData.tags.includes(trimmed)) {
        setFormData({ ...formData, tags: [...formData.tags, trimmed] });
      }
      setTagInput('');
    }
  };

  const removeTag = (indexToRemove) => {
    setFormData({
      ...formData,
      tags: formData.tags.filter((_, i) => i !== indexToRemove),
    });
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.3)" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {error && <div className="alert alert-danger">{error}</div>}
              <div className="form-group mb-3">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              {/* <div className="form-group mb-3">
                <label>Tags (comma separated)</label>
                <input
                  type="text"
                  className="form-control"
                  name="tags"
                  value={formData.tags}
                  onChange={handleChange}
                  placeholder="e.g. Red, Blue, Large"
                />
              </div>
               */}
               <div className="form-group mb-3">
                <label>Tags (press Enter or comma to add)</label>
                <div className="d-flex flex-wrap gap-2 mb-2">
                  {formData.tags.map((tag, i) => (
                    <span key={i} className="badge bg-primary">
                      {tag}
                      <button
                        type="button"
                        onClick={() => removeTag(i)}
                        className="btn btn-sm btn-danger text-light ms-2"
                        aria-label="Remove"
                      >x</button>
                    </span>
                  ))}
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type and press Enter or comma"
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={handleTagKeyDown}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={createLoading || updateLoading}
              >
                {createLoading || updateLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductAttributeForm;
